import React from "react";
import styled from "styled-components";
import CircleProgressBar from "../../ui/CircleProgressBar";
import { LabelText, TitleText } from "../../ui/Text";

interface ProgressCardProps {
  backgroundColor?: string;
  percent: number;
  title?: string;
  value?: number;
}

export const ProgressCard = ({
  backgroundColor,
  title,
  value,
  percent,
}: ProgressCardProps) => {
  return (
    <Container backgroundColor={backgroundColor}>
      <CircleProgressBar
        percentage={percent}
        maxSize="100vh"
        textColor="white"
      />
      <DetailsCard>
        <LabelText>{title}</LabelText>
        <TitleText>{value}</TitleText>
      </DetailsCard>
    </Container>
  );
};

const Container = styled.div<{ backgroundColor?: string }>`
  display: flex;
  padding: 1rem;
  margin-left: 1rem;
  width: 100%;
  align-items: center;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 0.75rem;
`;

const DetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  ${LabelText} {
    font-size: 18px;
    padding: 0;
    margin: 0 !important;
    color: #c3c4c9;
  }
  ${TitleText} {
    color: #ffffff !important;
    font-size: 1.5em;
    font-weight: 900 !important;
    padding: 0;
    margin: 0;
  }
`;
